import React, { PureComponent } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input
} from 'reactstrap'

export default class ConfirmDelete extends PureComponent {
  static defaultProps = {
    prompt: 'Are you sure you want to delete this item?',
    confirmText: 'Yes, Delete',
    cancelText: 'No, Go Back'
  }

  render() {
    return (
      <Modal
        isOpen={this.props.open}
        toggle={this.toggle}
        className={this.props.className}
      >
        <ModalHeader toggle={this.props.close}>Confirm</ModalHeader>
        <ModalBody>{this.props.prompt}</ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={this.props.onClose}
            disabled={this.props.buttonsDisabled}
          >
            {this.props.cancelText}
          </Button>
          <Button
            color="primary"
            onClick={this.props.onConfirm}
            disabled={this.props.buttonsDisabled}
          >
            {this.props.confirmText}
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Components/ConfirmDelete.js